// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"AccountLink_tooltip__2gq3y"};